<template>
  <q-page class="flex-center">

    <div class="q-pa-md">
      <div class="row">
        <div class="col-12">
          <general-chart/>
        </div>
      </div>
      <br>
     <midian-charts/>
      <br>
     <last-donators />
      <br>
      <DonationFromSource />
      <br>
     <donation-values />
    </div>
  </q-page>
</template>
<script>
import GeneralChart from '../components/GeneralChart';
import MidianCharts from '../components/MidianCharts';
import LastDonators from '../components/LastDonators';
import DonationValues from '../components/DonationValues';
import DonationFromSource from '../components/DonationFromSource';
export default {
  name: 'PageHome',
  components: {
    MidianCharts,
    GeneralChart,
    LastDonators,
    DonationValues,
    DonationFromSource
  }
};
</script>
